import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/resource_categories/${resource.id}/edit`} />,
    <MenuItem primaryText='Resources' key='resources' value={`/write-now/resources?filters[resource_category_id]=${resource.id}`} />
  ]
}

export default buildMenuItems
